import { atomWithReset as stateSegmentWithReset } from 'jotai/utils';
import { ParamsUsed } from '../../../types/store/markettingContentGeneration/majorProcessActions';
import {
  MarketingFormFieldRequest,
  PregenerateClaimsFeild,
  SecondaryFormApiField,
  VersionPayload,
} from '../../../types/MarketingBox';

export type ApiPayloadUsed =
  | (PregenerateClaimsFeild & MarketingFormFieldRequest)
  | (MarketingFormFieldRequest & VersionPayload & { sessionId: string })
  | (MarketingFormFieldRequest & SecondaryFormApiField & VersionPayload);

type Generate = {
  primaryLanguage: string;
  paramsUsed: ParamsUsed;
  contentId: string;
  isRefineContent?: boolean;
  isReGeneratingContent?: boolean;
  generateContentInitiated: boolean;
  apiPayloadUsed: ApiPayloadUsed;
  contentListReplica?: never[];
};

export const generateStateSegment = stateSegmentWithReset<Generate>({
  primaryLanguage: '',
  paramsUsed: {
    currentAvailableActionOptions: [],
    currentAvailableBrandOptions: [],
    currentAvailableIndicationOptions: [],
    currentAvailableCountryOptions: [],
    currentAvailableAudienceOptions: [],
    currentAvailableContentTypeOptions: [],
    currentAvailableSegmentOptions: [],
    currentAvailableSectionOptions: [],
    currentAvailableToneOptions: [],
    currentAvailablePlatformOptions: [],
    currentAvailableTopicOptions: [],
    currentAvailableContentStyleOptions: [],
    currentAvailableToneLevelOptions: [],
    currentSelectedAction: '',
    currentSelectedBrand: '',
    currentSelectedIndication: '',
    currentSelectedCountry: '',
    currentSelectedAudience: '',
    currentSelectedContentType: '',
    currentSelectedSegment: '',
    currentSelectedPlatform: '',
    currentSelectedSections: [],
    currentSelectedTone: '',
    currentSelectedTopic: [],
    currentSelectedExclusion: [],
    currentSelectedInclusion: [],
    currentSelectedDaring: false,
    currentSelectedCompassionate: false,
    currentSelectedModules: '',
    currentSelectedFile: [],
    currentSelectedLanguage: '',
    currentAvailableLanguageOptions: [],
    currentContextValue: '',
    currentSelectedApplicableRecommendation: [],
    currentSelectedUnbrandedFlag: false,
    currentSelectedContentStyle: '',
    currentSelectedToneLevel: '',
    currentSelectedExtendedLibraryFlag: false,
  },
  apiPayloadUsed: {
    brand: '',
    contentType: '',
    topics: [],
    targetAudience: '',
    sessionId: '',
    useSubstituteClaims: false,
    claims: [],
    action: '',
    indication: '',
    country: '',
    segment: '',
    sections: '',
    tone: '',
    platform: '',
    emailModules: '',
    fileData: [],
    contentGroupId: '',
    language: '',
    unbranded: false,
    context: { text: '' },
  },
  isRefineContent: false,
  isReGeneratingContent: false,
  generateContentInitiated: false,
  contentId: '',
  contentListReplica: [],
});

generateStateSegment.debugLabel = 'generateStateSegment';
